<template>
  <v-footer absolute class="bg-secondary">
    <div id="sns" class="column">
      <div class="sns">
        <ul class="sns_inner_ul">
          <li class="sns_inner_li" v-ripple>
            <span class="snsbutton fade">
              <!-- twitter -->
              <a
                href="http://twitter.com/share?&url=http://d-mebius.com/fusigi_na_shooting/"
                rel="nofollow"
              >
                <picture>
                  <souce
                    srcset="../assets/icon_twitter.webp"
                    type="image/webp"
                    width="64"
                    height="64"
                  />
                  <img
                    src="../assets/icon_twitter.png"
                    alt="ツイート"
                    width="64"
                    height="64"
                  />
                </picture>
              </a>
            </span>
          </li>
          <li class="sns_inner_li" v-ripple>
            <span class="snsbutton">
              <!-- facebook -->

              <a
                href="http://www.facebook.com/share.php?u=http://d-mebius.com/fusigi_na_shooting/"
                onclick="window.open(encodeURI(decodeURI(this.href)), 'FBwindow', 'width=554, height=470, menubar=no, toolbar=no, scrollbars=yes'); return false;"
                rel="nofollow"
              >
                <picture>
                  <souce
                    srcset="../assets/icon_fb.webp"
                    type="image/webp"
                    width="64"
                    height="64"
                  />
                  <img src="../assets/icon_fb.png" width="64" height="64" />
                </picture>
              </a>
            </span>
          </li>
        </ul>
        <!-- end .sns -->
      </div>
    </div>
    <div align="center">
      主催：株式会社メビウス
    </div>

    <div class="copyright">
      <div class="ma-auto text-center">
        <p>
          &copy;mebius
        </p>
      </div>
    </div>
  </v-footer>
</template>

<style scoped>
  #sns {
    margin: 50px auto;
  }
  .sns_inner_ul {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    margin: 20px auto;
  }
  .sns_inner_li {
    margin: 2px;
    width: 64px;
    height: 64px;
    position: relative;
    z-index: 0;
    display: block;
    overflow: hidden;
  }

  footer {
    width: 100%;
    display: block;
    position: relative;
    padding-top: 30px;
  }
  .logo {
    margin: 0 auto;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    flex-flow: wrap;
    padding-bottom: 20px;
  }
</style>
